import { render } from "./Videos.vue?vue&type=template&id=35b00cc5&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-35b00cc5"

export default script